/**
 * Runtime bootstrap config — fetched from /config/bootstrap before React mounts.
 * Replaces build-time VITE_AUTH_DISABLED env var.
 */

let _authDisabled = true;
let _rbacConfig: RbacBootstrap | null = null;

export interface RbacBootstrap {
  bypass_role: string;
  universal_routes: string[];
  sections: Record<string, {
    label: string;
    roles: string[];
    routes: string[];
  }>;
}

export function setAuthDisabled(value: boolean): void {
  _authDisabled = value;
}

export function isAuthDisabled(): boolean {
  return _authDisabled;
}

export function setRbacConfig(config: RbacBootstrap): void {
  _rbacConfig = config;
}

export function getRbacConfig(): RbacBootstrap | null {
  return _rbacConfig;
}
